import { render, staticRenderFns } from "./EbillDataPage.vue?vue&type=template&id=b3e0d352"
import script from "./EbillDataPage.vue?vue&type=script&lang=js"
export * from "./EbillDataPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports